import React from 'react';
import { CircularProgress } from '@material-ui/core';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(237, 237, 237, 0.75);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
`;

const LoadingScreen = () => {
    return (
        <LoadingWrapper>
            <CircularProgress color="secondary" />
        </LoadingWrapper>
    );
};

export default LoadingScreen;
